import { computed, getCurrentInstance } from "vue";

import features from "shared/services/features";
import StorageService from "shared/services/StorageService";
import { useUserStore } from "shared/stores/user";

export default function useContentWarning() {
  const root = getCurrentInstance().proxy;

  const showContentWarning = computed(() => {
    const restrictedFeatures = [
      "has_mediatrack_nla_regional",
      "has_nla_eclips_print",
      "has_uk_clipped_content_cla",
      "has_uk_clipped_content_nla",
    ];

    const { organisation } = useUserStore();

    if (organisation.region === "uk") {
      restrictedFeatures.push("has_wise_cla", "has_wise_nla");
    }

    return features.hasAny(restrictedFeatures);
  });

  async function openContentWarningModal(view, props = {}) {
    const storageKey = `showContentWarning${view}`;
    const hideModal = await StorageService.get(storageKey);

    return new Promise((resolve) => {
      if (!showContentWarning.value || hideModal) {
        resolve();

        return;
      }

      root.$modals.open("ContentWarningModal", {
        events: {
          close: () => {
            resolve();
          },
          confirm: (hideWarning) => {
            if (props.canIgnore) {
              StorageService.set(storageKey, hideWarning);
            }

            resolve();
          },
        },
        props,
      });
    });
  }

  function openAddMentionStreamContentWarningModal() {
    return openContentWarningModal("AddMentionStream", {
      canIgnore: true,
      offsetMenu: true,
    });
  }

  function openSearchCoverageContentWarningModal() {
    return openContentWarningModal("SearchCoverage", {
      canIgnore: true,
    });
  }

  function openShareMentionStreamContentWarningModal() {
    return openContentWarningModal("ShareMentionStream", {
      canIgnore: true,
      offsetMenu: true,
    });
  }

  function openShareMentionContentWarningModal() {
    return openContentWarningModal("ShareMention", {
      offsetMenu: true,
    });
  }

  function openScheduledReportContentWarningModal() {
    return openContentWarningModal("ScheduledReport", {
      canIgnore: true,
      offsetMenu: true,
    });
  }

  function openNotificationContentWarningModal() {
    return openContentWarningModal("Notification", {
      canIgnore: true,
      offsetMenu: true,
    });
  }

  return {
    openAddMentionStreamContentWarningModal,
    openContentWarningModal,
    openNotificationContentWarningModal,
    openScheduledReportContentWarningModal,
    openSearchCoverageContentWarningModal,
    openShareMentionContentWarningModal,
    openShareMentionStreamContentWarningModal,
    showContentWarning,
  };
}
